import React, { useEffect, useState } from 'react';
import settingApis from '../apis';
import { IGetSupplierParam } from '../types/api';
import { IResSupplier } from '../types/supplier';
import { IResponseDataBody } from 'services/response';

const useGetSupplier = (lazy = false) => {
  const [data, setData] = useState<IResSupplier[]>([]);
  const [page, setPage] = useState(1);
  const [totalElements, setTotalElements] = useState(0);
  const [loading, setLoading] = useState(false);

  const getSuppliers = async (params: IGetSupplierParam) => {
    try {
      const res: IResponseDataBody<{ content: IResSupplier[]; totalElements: number }> = await settingApis.getSuppliers(
        params
      );
      if (res.data.data?.content) {
        setData(res.data.data.content);
        setTotalElements(res.data.data.totalElements);
      }
    } catch (error) {
      setData([]);
      setTotalElements(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!lazy) {
      getSuppliers({ page, size: 10 });
    }
  }, [lazy]);
  return { data, getSuppliers, loading, page, setPage, totalElements };
};

export default useGetSupplier;
